<template>
  <div class="phrase-page">
    <header class="heading">
      <div><h1>客服话术</h1><p>维护问题和回复，移动端同步使用。只复制答案，不会自动发送消息。</p></div>
      <el-button icon="el-icon-refresh" :loading="loading" @click="refresh">刷新</el-button>
    </header>
    <el-alert v-if="error" :title="error" type="error" show-icon :closable="false" class="error" />
    <div class="workspace">
      <aside class="categories">
        <div class="panel-title"><strong>分类</strong><el-button size="mini" @click="categoryManager = true">管理分类</el-button></div>
        <button type="button" :class="{ selected: categoryId === '' }" @click="selectCategory('')">全部分类</button>
        <button v-for="category in categories" :key="category.id" type="button" :class="{ selected: categoryId === category.id }" @click="selectCategory(category.id)">
          {{ category.name }} <small v-if="!category.status">停用</small>
        </button>
        <p class="hint">分类停用后，其全部话术在移动端隐藏。排序数值越大越靠前。</p>
      </aside>
      <main class="entries">
        <div class="toolbar">
          <el-input v-model="keyword" clearable maxlength="160" placeholder="搜问题、关键词、答案或 /快捷指令" @keyup.enter.native="search" @clear="search" />
          <el-select v-model="status" @change="search"><el-option label="全部状态" value="" /><el-option label="启用" :value="1" /><el-option label="停用" :value="0" /></el-select>
          <el-button icon="el-icon-search" @click="search">搜索</el-button>
          <el-button type="primary" icon="el-icon-plus" :disabled="!categories.length" @click="edit()">新增话术</el-button>
        </div>
        <div class="list-summary">{{ total }} 条话术 <span>热门按推荐与复制次数排序；复制次数不代表已发送。</span></div>
        <el-table v-loading="loading" :data="items" row-key="id" empty-text="暂无匹配话术，可调整筛选或新增">
          <el-table-column label="问题 / 快捷指令" min-width="210"><template slot-scope="scope">
            <strong>{{ scope.row.question }}</strong><div class="meta"><span>{{ scope.row.category_name }}</span> <code v-if="scope.row.shortcut">/{{ scope.row.shortcut }}</code></div>
            <small class="keywords">{{ scope.row.keywords }}</small>
          </template></el-table-column>
          <el-table-column label="答案预览" min-width="240"><template slot-scope="scope"><div class="answer-preview">{{ scope.row.answer }}</div></template></el-table-column>
          <el-table-column label="展示" width="100"><template slot-scope="scope">
            <el-tag size="mini" :type="scope.row.status && Number(scope.row.category_status) === 1 ? 'success' : 'info'">{{ scope.row.status && Number(scope.row.category_status) === 1 ? '启用' : '停用' }}</el-tag>
            <el-tag v-if="scope.row.is_featured" size="mini" type="warning">推荐</el-tag>
          </template></el-table-column>
          <el-table-column prop="sort" label="排序" width="65" />
          <el-table-column prop="copy_count" label="复制次数" width="90" />
          <el-table-column label="操作" width="190" fixed="right"><template slot-scope="scope">
            <el-button type="text" @click="preview = scope.row">预览</el-button>
            <el-button type="text" @click="edit(scope.row)">编辑</el-button>
            <el-button type="text" class="danger" @click="remove(scope.row)">删除</el-button>
          </template></el-table-column>
        </el-table>
        <el-pagination class="pagination" background layout="total, prev, pager, next" :page-size="20" :total="total" :current-page="page" @current-change="changePage" />
      </main>
    </div>

    <el-dialog :title="form.id ? '编辑话术' : '新增话术'" :visible.sync="editor" width="720px" :close-on-click-modal="false" :close-on-press-escape="!saving" :show-close="!saving">
      <el-alert v-if="conflict" title="内容已被其他人修改。请保留未保存的内容，关闭后刷新列表再编辑。" type="warning" :closable="false" />
      <el-form ref="entryForm" :model="form" :rules="rules" label-width="95px" class="edit-form">
        <el-form-item label="问题标题" prop="question"><el-input v-model="form.question" maxlength="160" show-word-limit placeholder="例如：下载后如何安装并激活？" /></el-form-item>
        <el-form-item label="分类" prop="category_id"><el-select v-model="form.category_id"><el-option v-for="category in categories" :key="category.id" :label="category.name + (category.status ? '' : '（已停用）')" :value="category.id" /></el-select></el-form-item>
        <el-form-item label="答案" prop="answer"><el-input v-model="form.answer" type="textarea" :rows="8" maxlength="10000" show-word-limit placeholder="客服复制发送给客户的纯文本；支持多行" /></el-form-item>
        <el-form-item label="搜索关键词"><el-input v-model="form.keywords" maxlength="500" show-word-limit placeholder="客户可能输入的叫法，例如 苹果 mac 安装 激活" /></el-form-item>
        <el-form-item label="快捷指令" prop="shortcut"><el-input v-model="form.shortcut" maxlength="32" placeholder="例如 download，手机输入 /download 即可定位"><template slot="prepend">/</template></el-input><small class="hint">1~32 位字母、数字、下划线、短横线；全库唯一，可留空。</small></el-form-item>
        <el-form-item label="展示设置"><el-switch v-model="form.status" :active-value="1" :inactive-value="0" active-text="启用" /><el-checkbox v-model="form.is_featured" :true-label="1" :false-label="0" class="featured">热门推荐</el-checkbox></el-form-item>
        <el-form-item label="排序"><el-input-number v-model="form.sort" :min="0" :max="999999" :precision="0" /><small class="hint">数字越大越靠前</small></el-form-item>
      </el-form>
      <span slot="footer"><el-button :disabled="saving" @click="editor = false">取消</el-button><el-button type="primary" :loading="saving" @click="save">保存</el-button></span>
    </el-dialog>

    <el-dialog title="分类管理" :visible.sync="categoryManager" width="650px" :close-on-click-modal="false">
      <el-button type="primary" size="small" @click="editCategory()">新增分类</el-button>
      <el-table :data="categories" row-key="id">
        <el-table-column prop="name" label="分类" /><el-table-column prop="sort" label="排序" width="65" />
        <el-table-column label="状态" width="70"><template slot-scope="scope">{{ scope.row.status ? '启用' : '停用' }}</template></el-table-column>
        <el-table-column label="操作" width="125"><template slot-scope="scope"><el-button type="text" @click="editCategory(scope.row)">编辑</el-button><el-button type="text" class="danger" @click="removeCategory(scope.row)">删除</el-button></template></el-table-column>
      </el-table>
      <p class="hint">非空分类不能删除。请先把分类中的话术转移或删除，停用条目也需处理。</p>
    </el-dialog>
    <el-dialog :title="categoryForm.id ? '编辑分类' : '新增分类'" :visible.sync="categoryEditor" width="440px" append-to-body :close-on-click-modal="false" :show-close="!categorySaving" :close-on-press-escape="!categorySaving">
      <el-form label-width="65px"><el-form-item label="名称"><el-input v-model="categoryForm.name" maxlength="64" /></el-form-item><el-form-item label="排序"><el-input-number v-model="categoryForm.sort" :min="0" :max="999999" :precision="0" /></el-form-item><el-form-item label="状态"><el-switch v-model="categoryForm.status" :active-value="1" :inactive-value="0" active-text="启用" /></el-form-item></el-form>
      <p class="hint">停用分类会隐藏其中全部移动端话术，答案不会被删除。</p>
      <span slot="footer"><el-button :disabled="categorySaving" @click="categoryEditor = false">取消</el-button><el-button type="primary" :loading="categorySaving" @click="saveCategory">保存</el-button></span>
    </el-dialog>
    <el-dialog title="回复预览" :visible="!!preview" width="650px" @close="preview = null">
      <template v-if="preview"><h3>{{ preview.question }}</h3><div class="full-answer">{{ preview.answer }}</div><el-button type="primary" @click="copy(preview.answer)">复制答案</el-button></template>
    </el-dialog>
    <textarea ref="copyArea" class="copy-area" readonly aria-hidden="true" tabindex="-1"></textarea>
  </div>
</template>

<script>
import api from '@/api/supportPhrase'

// 2026-10-05：所有维护都通过新话术接口；不复用音效业务表、日志或修改其他页面结构。
const emptyEntry = categoryId => ({ id: 0, category_id: categoryId || '', question: '', answer: '', keywords: '', shortcut: '', status: 1, is_featured: 0, sort: 0 })
export default {
  name: 'SupportPhrases',
  data() {
    return {
      categories: [], items: [], categoryId: '', keyword: '', status: '', page: 1, total: 0,
      loading: false, error: '', requestVersion: 0, editor: false, saving: false, conflict: false,
      form: emptyEntry(), categoryManager: false, categoryEditor: false, categorySaving: false,
      categoryForm: {}, preview: null,
      rules: {
        question: [{ required: true, whitespace: true, message: '请输入问题标题', trigger: 'blur' }],
        answer: [{ required: true, whitespace: true, message: '请输入答案', trigger: 'blur' }],
        category_id: [{ required: true, message: '请选择分类', trigger: 'change' }],
        shortcut: [{ pattern: /^[a-z0-9][a-z0-9_-]{0,31}$/i, message: '指令格式不正确', trigger: 'blur' }]
      }
    }
  },
  created() { this.refresh() },
  methods: {
    // 2026-10-05：业务失败包含版本冲突，保持编辑框及原输入，不清除登录信息。
    result(response) {
      const body = response.data
      if (!body || body.code !== 1) {
        const error = new Error((body && body.msg) || '话术操作失败，请重试')
        error.conflict = body && body.code === 409
        throw error
      }
      return body.data
    },
    failure(error) { return error && error.message ? error.message : String(error || '无法连接服务，请重试') },
    // 2026-10-05：刷新分类后再读列表；失败可见且可重试，不把失败伪装成空库。
    async refresh() {
      try {
        this.categories = this.result(await api.categories({ manage: 1 }))
        if (this.categoryId && !this.categories.some(item => item.id === this.categoryId)) this.categoryId = ''
        await this.load()
      } catch (error) { this.error = this.failure(error) }
    },
    // 2026-10-05：请求序号隔离快速切分类/翻页的迟到响应，旧结果不能覆盖新筛选。
    async load() {
      const version = ++this.requestVersion
      this.loading = true
      this.error = ''
      try {
        const data = this.result(await api.read({ manage: 1, keyword: this.keyword, category_id: this.categoryId, status: this.status, page: this.page, page_size: 20 }))
        if (version !== this.requestVersion) return
        this.items = data.items
        this.total = Number(data.total)
        if (this.page > 1 && !this.items.length) { this.page--; return this.load() }
      } catch (error) { if (version === this.requestVersion) this.error = this.failure(error) }
      finally { if (version === this.requestVersion) this.loading = false }
    },
    selectCategory(id) { this.categoryId = id; this.search() },
    search() { this.page = 1; this.load() },
    changePage(page) { this.page = page; this.load() },
    // 2026-10-05：复制列表记录作为独立编辑草稿，取消不会污染列表；保存携带读取时的 version。
    edit(row) {
      this.form = row ? { ...row, shortcut: row.shortcut || '' } : emptyEntry(this.categoryId || (this.categories[0] && this.categories[0].id))
      this.conflict = false
      this.editor = true
      this.$nextTick(() => this.$refs.entryForm && this.$refs.entryForm.clearValidate())
    },
    async save() {
      if (this.saving) return
      const valid = await this.$refs.entryForm.validate().catch(() => false)
      if (!valid) return
      this.saving = true
      try {
        this.result(await api.save(this.form))
        this.editor = false
        this.$message.success('话术已保存')
        await this.load()
      } catch (error) { this.conflict = !!error.conflict; this.$message.error(this.failure(error)) }
      finally { this.saving = false }
    },
    // 2026-10-05：删除必须确认，并按列表版本删除；别人刚改过的条目不会被误删。
    async remove(row) {
      try {
        await this.$confirm(`删除“${row.question}”？移动端将不再展示。`, '删除话术', { type: 'warning' })
        this.result(await api.remove({ id: row.id, version: row.version }))
        this.$message.success('已删除')
        await this.load()
      } catch (error) { if (error !== 'cancel' && error !== 'close') this.$message.error(this.failure(error)) }
    },
    editCategory(row) { this.categoryForm = row ? { ...row } : { id: 0, name: '', status: 1, sort: 0 }; this.categoryEditor = true },
    // 2026-10-05：分类保存失败保留草稿；名称长度和状态还会由服务端再次验证。
    async saveCategory() {
      if (this.categorySaving) return
      if (!this.categoryForm.name || !this.categoryForm.name.trim()) return this.$message.warning('请输入分类名称')
      this.categorySaving = true
      try {
        this.result(await api.saveCategory(this.categoryForm))
        this.categoryEditor = false
        this.$message.success('分类已保存')
        await this.refresh()
      } catch (error) { this.$message.error(this.failure(error)) }
      finally { this.categorySaving = false }
    },
    async removeCategory(row) {
      try {
        await this.$confirm(`删除分类“${row.name}”？分类必须没有未删除话术。`, '删除分类', { type: 'warning' })
        this.result(await api.removeCategory({ id: row.id, version: row.version }))
        await this.refresh()
      } catch (error) { if (error !== 'cancel' && error !== 'close') this.$message.error(this.failure(error)) }
    },
    // 2026-10-05：后台预览也复制完整多行纯文本；不统计为客服热门，避免维护行为污染排序。
    async copy(answer) {
      try {
        if (window.isSecureContext && navigator.clipboard && navigator.clipboard.writeText) {
          try { await navigator.clipboard.writeText(answer); this.$message.success('答案已复制'); return }
          catch (error) { console.warn('[support-phrase] native copy unavailable:', error && error.name) }
        }
        const area = this.$refs.copyArea
        area.value = answer; area.focus(); area.select(); area.setSelectionRange(0, answer.length)
        if (!document.execCommand('copy')) throw new Error('请在预览中选中答案手动复制')
        this.$message.success('答案已复制')
      } catch (error) { this.$message.error(this.failure(error)) }
      finally { this.$refs.copyArea.blur() }
    }
  }
}
</script>

<style scoped lang="scss">
.phrase-page { padding: 24px; color: #26354a; background: #f5f7fa; min-height: 100%; }
.heading { display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; h1 { font-size: 24px; margin: 0 0 8px; } p { color: #738197; margin: 0; } }
.error { margin-bottom: 16px; }
.workspace { display: grid; grid-template-columns: 225px minmax(0, 1fr); gap: 18px; }
.categories, .entries { background: #fff; border: 1px solid #e4e9f0; border-radius: 8px; padding: 18px; }
.panel-title { display: flex; align-items: center; justify-content: space-between; margin-bottom: 14px; }
.categories > button { display: block; width: 100%; text-align: left; padding: 12px; border: 0; background: none; color: #42546d; border-radius: 6px; cursor: pointer; margin-bottom: 4px; }
.categories > button.selected { background: #edf4ff; color: #276be8; font-weight: 600; }
.categories small { float: right; color: #8b98ac; }
.hint { color: #8b98ac; font-size: 12px; line-height: 1.7; }
.toolbar { display: flex; gap: 10px; .el-input { flex: 1; } .el-select { width: 110px; } .el-button { margin-left: 0; } }
.list-summary { margin: 18px 0; font-size: 14px; span { margin-left: 12px; font-size: 12px; color: #8b98ac; } }
.meta { margin: 6px 0; color: #71849e; font-size: 12px; code { margin-left: 8px; color: #276be8; } }
.keywords { color: #99a4b5; }
.answer-preview { white-space: pre-wrap; display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden; word-break: break-word; color: #61738b; }
.full-answer { white-space: pre-wrap; overflow-wrap: anywhere; line-height: 1.8; background: #f7f9fc; padding: 18px; border-radius: 6px; margin-bottom: 20px; max-height: 50vh; overflow-y: auto; }
.pagination { margin-top: 20px; text-align: right; }
.danger { color: #e35c5c; }
.edit-form { margin-top: 18px; }
.featured { margin-left: 24px; }
.copy-area { position: fixed; left: -9999px; top: 0; opacity: 0; }
@media (max-width: 1100px) { .workspace { grid-template-columns: 1fr; } .categories > button { display: inline-block; width: auto; } .categories .hint { margin: 8px 0 0; } .toolbar { flex-wrap: wrap; } }
</style>
